import { createContext, useContext, useReducer, useState } from 'react';
import ajaxReport from '../util/remote/ajaxReport';

const initialState = { 
    reportTestConfig: null,
    selectedTests: [],
    reportListing: false,
    activeReport: null,
    marksheet: null,
    loadingMarksheet: false,
    mounted: false,
    reportId: null,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
};


const ReportContext = createContext();

export const ReportProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [removeComment, setRemoveComment] = useState({show: false, comment: null, callback: null});
  const [commentWriter, setCommentWriter] = useState({show: false, report: null, callback: null});
  const [autoCommentControl, setAutoCommentControl] = useState({
    show: false,
    report: null,
    enable: false,
    callback: null,
});

  const setReportTest = (test) =>{
    dispatch({ type: 'reportTestConfig', payload: test });
  }

  const setSelectedTests = (tests) => {
    dispatch({ type: 'selectedTests', payload: tests });
  }
  
  const getReports = async(refresh)=>{
    if(!refresh && state.reportListing){
      return; // Do not fetch if already fetched and not refreshing
    }
    const server_response = await ajaxReport.getReports({page: 1});
    if(server_response.status === "OK"){
        dispatch({ type: 'reportListing', payload: server_response.details.data });
    }else{
      dispatch({ type: 'reportListing', payload: "404" });
    }
  }

  const setActiveReport = (report) => {
    dispatch({ type: 'activeReport', payload: report });
  }

  const generateMarksheet=async(refresh, reportId)=>{
    
      if(!refresh && state.marksheet){
          return; // Do not fetch if already fetched and not refreshing
      }
      dispatch({type: 'mounted', payload: true});
      dispatch({ type: 'loadingMarksheet', payload: true });
      dispatch({ type: 'reportId', payload: reportId });
      dispatch({ type: 'marksheet', payload: null });
      const server_response = await ajaxReport.generateMarksheet({"report_id": reportId});
      dispatch({ type: 'loadingMarksheet', payload: false });
      if(server_response.status==="OK"){
          dispatch({ type: 'marksheet', payload: server_response.details });
      }else{
          dispatch({ type: 'marksheet', payload: "404" });          
      }
  }

  return(
    <ReportContext.Provider value={{
      ...state,
      removeComment,
      commentWriter,
      autoCommentControl,
      setCommentWriter,
      setRemoveComment, 
      dispatch,
      setReportTest,
      setSelectedTests,
      getReports,
      setActiveReport,
      generateMarksheet,
      setAutoCommentControl,
      }}>
      {children}
    </ReportContext.Provider>
  )

}

export const useReport = ()=>useContext(ReportContext);

